import { render, staticRenderFns } from "./DisableAlerts.vue?vue&type=template&id=b40449b0&scoped=true&lang=html"
import script from "./DisableAlerts.vue?vue&type=script&lang=js"
export * from "./DisableAlerts.vue?vue&type=script&lang=js"
import style0 from "./DisableAlerts.vue?vue&type=style&index=0&id=b40449b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40449b0",
  null
  
)

export default component.exports